import { WalletPaymentSteps } from '@/types/enums/forms/wallet/walletPaymentSteps';
import { WALLET_REQUEST_PHRASES } from '@/consts/phrases/walletPhrases';
import { IWalletStartPaymentFormDetails } from '@/types/types';
import { ModelData } from '@/types/types/forms/modelData';

export const walletFormModel: {
    formId: string;
    [WalletPaymentSteps.PaymentStart]: ModelData<keyof IWalletStartPaymentFormDetails>;
} = {
    formId: 'walletRequestForm',
    [WalletPaymentSteps.PaymentStart]: {
        lastPaymentMethodId: {
            name: 'lastPaymentMethodId',
            label: WALLET_REQUEST_PHRASES.REPEAT_TITLE,
        },
        paymentMethodId: {
            name: 'paymentMethodId',
            label: WALLET_REQUEST_PHRASES.SELECT_PAYMENT_TITLE,
        },
        amount: {
            name: 'amount',
            label: WALLET_REQUEST_PHRASES.AMOUNT,
        },
        lastPayment: {
            name: 'lastPayment',
            label: 0,
        },
        existingPayment: {
            name: 'existingPayment',
            label: 0,
        },
    } as const,
};
